// Regras de parcelamento da maquineta, por marca:
// Clinica Sim   ate 12x, parcela minima R$ 50
// Super Clinica ate 10x, parcela minima R$ 10
export const MAX_PARCELAS_PADRAO = 12;
export const MAX_PARCELAS_SUPER_CLINICA = 10;
export const PARCELA_MINIMA_PADRAO = 50;
export const PARCELA_MINIMA_SUPER_CLINICA = 10;

export function maxParcelas(isSuperClinica: boolean): number {
  return isSuperClinica ? MAX_PARCELAS_SUPER_CLINICA : MAX_PARCELAS_PADRAO;
}

export function parcelaMinima(isSuperClinica: boolean): number {
  return isSuperClinica ? PARCELA_MINIMA_SUPER_CLINICA : PARCELA_MINIMA_PADRAO;
}

// Sempre devolve pelo menos [1]: valor abaixo da parcela minima ainda pode ser cobrado a vista.
export function parcelasDisponiveis(valor: number, isSuperClinica: boolean): number[] {
  const max = Math.min(maxParcelas(isSuperClinica), Math.floor((valor || 0) / parcelaMinima(isSuperClinica)));
  const maxFinal = max < 1 ? 1 : max;
  return Array.from({ length: maxFinal }, (_, i) => i + 1);
}

// A opcao escolhida deixa de existir quando o operador reduz o valor (R$ 600 em 12x -> R$ 100).
export function parcelaValida(parcelas: number, valor: number, isSuperClinica: boolean): number {
  const opcoes = parcelasDisponiveis(valor, isSuperClinica);
  return opcoes.includes(parcelas) ? parcelas : opcoes[opcoes.length - 1];
}
